<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'Resource',
  data() {
    return {
      search: '',
      settings: {
        maxScrollbarLength: 60
      },
      products: [],
      oproducts: [],
      resources: [],
      oresources: [],
      isOpen: false,
      current: {},
      submitProduct: {}
    }
  },
  created() {
    this.getProducts()
  },
  computed: {
    filterResources() {
      if (this.submitProduct.productcode) {
        const result = [];
        this.resources.forEach(resource => {
          const data = resource.data ? resource.data.filter(o => o.product_id === this.submitProduct.productid) : [];
          if (data && data.length) {
            result.push({
              name: resource.name,
              data
            })
          }
        })
        return result;
      } else {
        return this.resources;
      }
    }
  },
  methods: {
    getProducts() {
      this.axios.get('ajax_product.php', {
        // params: {
        //   keyword: this.search
        // }
      }).then((response) => {
        this.products = response.data.products;
        this.oproducts = response.data.products;
        this.resources = response.data.resources;
      })
    },
    filterProducts() {
      this.products = this.oproducts.filter(o => o.productcode.toLowerCase().indexOf(this.search.toLowerCase()) > -1);
    }
  },
  components: {
    VuePerfectScrollbar
  }
}
</script>